import React, { useEffect } from "react";
import Header from "../../../../layouts/header/Header";
import Footer from "../../../../layouts/footer/Footer";
import CallIcon2 from "../../../../icons/CallIcon2";
import MailIcon from "../../../../icons/MailIcon";
import { Button } from "../../../../shadcn/components/ui/button";
import { Dropdown } from "../../../../shadcn/components/custom/Dropdown";
import MapPinContactUs from "../../../../icons/MapPinContactUs";
import { BetaForm as useBetaForm } from "@reusejs/react";
import { getTopics, contactUs } from "services";
import OfficeLocationCard from "./OfficeLocationCard";

export const ContactUsPage = () => {
  const form = useBetaForm({
    first_name: "",
    last_name: "",
    email: "",
    mobile_number: "",
    topic: "",
    message: "",
  });
  const mobileNumberRegEx: RegExp = /^[0-9]{10}$/;
  const form_constraints = {
    first_name: {
      presence: {
        allowEmpty: false,
      },
    },
    last_name: {
      presence: {
        allowEmpty: false,
      },
    },
    email: {
      presence: {
        allowEmpty: false,
      },
      email: true,
    },
    mobile_number: {
      presence: {
        allowEmpty: false,
      },
      format: {
        pattern: mobileNumberRegEx,
        message: "^Mobile number is not valid.",
      },
      length: {
        maximum: 10,
        message: "^Mobile number is too long (maximum is 10 characters)",
      },
    },
    topic: {
      presence: {
        allowEmpty: true,
      },
    },
    message: {
      presence: {
        allowEmpty: true,
      },
    },
  };

  interface OfficeLocations {
    city?: string;
    address?: string;
  }
  const officeLocations: OfficeLocations[] = [
    {
      city: "Hyderabad",
      address: `ARCA EMART PVT LTD (Auctionbazaar.com) 6-3-1090/1/1, II Floor,
              Part B, Uma Hyderabad House Rajbhavan Road, Somajiguda, Hyderabad
              – 500082 Telangana, India`,
    },
    {
      city: "Bangalore",
      address: `ARCA EMART PVT LTD (Auctionbazaar.com) Janardhana towers - 4th
              floor, 133/2, residency road, above IOB bank, Opp. Bishop cotton
              boys school Bengaluru, Karnataka - 560025`,
    },
    {
      city: "Chennai",
      address: `ARCA EMART PVT LTD (Auctionbazaar.com) Dhwarco Business Center,
              12C/1, Ground floor, South Phase, Industrial Estate, Guindy,
              Chennai – 600032`,
    },
  ];

  useEffect(() => {
    form.setValidationRules(form_constraints);
  }, []);

  const hanldeSubmit = async () => {
    try {
      if (form.validate()) {
        form.value.email = form.value.email.trim()?.toLowerCase();
        await contactUs(form.value).then((res) => {
          form.setField("first_name", "");
          form.setField("last_name", "");
          form.setField("email", "");
          form.setField("mobile_number", "");
          form.setField("topic", "");
          form.setField("message", "");
        });
      }
    } catch (error: any) {
      console.log("check here error", error);
    }
  };
  return (
    <>
      {" "}
      <Header />
      <div className="px-customPaddingMobile lg:px-customPadding pt-2 lg:py-8 lg:pt-10 lg:pb-5 mt-2 lg:mt-0 2xl:w-[1340px] 2xl:mx-auto 2xl:px-0">
        <div className="lg:flex   lg:justify-between">
          {/* Heading */}
          <div className="max-w-[529px] lg:mt-[18px] mr-4">
            <p className="font-spaceGrotesk font-normal text-mobile-h1 lg:text-web-h1 leading-9 lg:leading-20 text-brand-textBlack">
              WE WOULD LOVE TO HEAR FROM YOU
            </p>
            <div className="flex space-x-3 mt-9 lg:mt-12">
              <CallIcon2 />
              <div>
                <p className="font-openSans font-normal text-mobile-body-sm leading-3 text-brand-textGrey">
                  Phone
                </p>
                <p className="mt-[10px] font-openSans font-normal text-mobile-subheading leading-5 text-brand-textBlack">
                  +91 83709 69696
                </p>
              </div>
            </div>
            <div className="flex space-x-3 mt-10 lg:mt-[60px]">
              <MailIcon />
              <div>
                <p className="font-openSans font-normal text-mobile-body-sm leading-3 text-brand-textGrey">
                  Email
                </p>
                <p className="mt-[10px] font-openSans font-normal text-mobile-subheading leading-5 text-brand-textBlack">
                  contact@auctionbazaar.com
                </p>
              </div>
            </div>
          </div>

          {/* Form */}
          <div className="bg-[#F8F8F8] w-full lg:max-w-[634px] mt-7 lg:mt-0  clip-path-bottomRightFooterMobile px-3 lg:px-[60px] pt-9 pb-7 ">
            <div className="lg:grid lg:grid-cols-2 space-y-8 lg:space-y-0 gap-x-5 gap-y-8">
              <div>
                <input
                  type="text"
                  value={form.getField("first_name")}
                  onChange={(e) => form.setField("first_name", e.target.value)}
                  className=" border-gray-200 w-full focus:border-brand-orange focus:ring-brand-orange placeholder:font-openSans placeholder:font-normal placeholder:text-web-body-lg placeholder:leading-5 placeholder:text-brand-textLightGrey"
                  placeholder="First Name*"
                />
                {form.errors.get("first_name") ? (
                  <p className="mt-1 text-sm text-red-500">
                    {form.errors.get("first_name")[0]}
                  </p>
                ) : null}
              </div>
              <div>
                <input
                  type="text"
                  value={form.getField("last_name")}
                  onChange={(e) => form.setField("last_name", e.target.value)}
                  className=" border-gray-200 w-full focus:border-brand-orange focus:ring-brand-orange placeholder:font-openSans placeholder:font-normal placeholder:text-web-body-lg placeholder:leading-5 placeholder:text-brand-textLightGrey"
                  placeholder="Last Name*"
                />
                {form.errors.get("last_name") ? (
                  <p className="mt-1 text-sm text-red-500">
                    {form.errors.get("last_name")[0]}
                  </p>
                ) : null}
              </div>
              <div>
                <input
                  type="text"
                  value={form.getField("email")}
                  onChange={(e) => form.setField("email", e.target.value)}
                  className=" border-gray-200 w-full focus:border-brand-orange focus:ring-brand-orange placeholder:font-openSans placeholder:font-normal placeholder:text-web-body-lg placeholder:leading-5 placeholder:text-brand-textLightGrey"
                  placeholder="Email ID*"
                />
                {form.errors.get("email") ? (
                  <p className="mt-1 text-sm text-red-500">
                    {form.errors.get("email")[0]}
                  </p>
                ) : null}
              </div>
              <div>
                <input
                  type="text"
                  value={form.getField("mobile_number")}
                  onChange={(e) =>
                    form.setField("mobile_number", e.target.value)
                  }
                  className=" border-gray-200 w-full focus:border-brand-orange focus:ring-brand-orange placeholder:font-openSans placeholder:font-normal placeholder:text-web-body-lg placeholder:leading-5 placeholder:text-brand-textLightGrey"
                  placeholder="Phone Number*"
                />
                {form.errors.get("mobile_number") ? (
                  <p className="mt-1 text-sm text-red-500">
                    {form.errors.get("mobile_number")[0]}
                  </p>
                ) : null}
              </div>
            </div>
            <div className="mt-8">
              <Dropdown
                dataSource={() => {
                  const data: any = getTopics();
                  return data;
                }}
                styles={{
                  outerContainer:
                    "rounded-none text-web-body-sm border border-gray-200 placeholder:font-openSans placeholder:font-normal placeholder:text-web-body-lg placeholder:leading-5 placeholder:text-brand-textLightGrey",
                }}
                defaultSelected={form.getField("topic")}
                onChange={(value: any) => form.setField("topic", value)}
                valueKey="value"
                placeholder="Topic"
              />
              {form.errors.get("topic") ? (
                <p className="mt-1 text-sm text-red-500">
                  {form.errors.get("topic")[0]}
                </p>
              ) : null}
            </div>
            <div>
              <textarea
                value={form.getField("message")}
                onChange={(e) => form.setField("message", e.target.value)}
                className="w-full pt-[12px] pb-[100px] lg:h-[150px] mt-8  border-gray-200 text-wrap focus:border-brand-orange focus:ring-brand-orange placeholder:font-openSans placeholder:font-normal placeholder:text-web-body-lg placeholder:leading-5 placeholder:text-brand-textLightGrey"
                placeholder="Message*"
              />
              {form.errors.get("message") ? (
                <p className="mt-1 text-sm text-red-500">
                  {form.errors.get("message")[0]}
                </p>
              ) : null}
            </div>
            <p className="mt-5 lg:mt-4 font-openSans font-normal text-mobile-body-sm lg:text-web-body-md leading-4 lg:leading-5 text-brand-textLightGrey">
              By submitting this form you agree to our terms and conditions and
              our Privacy Policy which explains how we may collect, use and
              disclose your personal information including to third parties.
            </p>
            <Button
              size={"custom"}
              onClick={hanldeSubmit}
              className="mt-4 lg:mt-10 w-[158px] h-10 lg:w-[188px] lg:h-[60px] font-openSans font-semibold text-mobile-body-md lg:text-[22px] leading-4 text-brand-bgWhite lg:leading-[30px] "
            >
              Submit
            </Button>
          </div>
        </div>
      </div>
      {/* Visit our Office */}
      <div className="px-customPaddingMobile lg:px-customPadding py-[42px] lg:pb-[60px] lg:mt-20 lg:flex lg:items-center lg:justify-between 2xl:w-[1292px] 2xl:mx-auto 2xl:px-0">
        <p className="font-spaceGrotesk lg:max-w-[340px] lg:mr-3 font-normal text-mobile-h2 lg:text-[60px] leading-9 lg:leading-[80px] text-brand-textBlack">
          VISIT OUR OFFICES TODAY
        </p>
        <div>
          {officeLocations.map((item, index) => (
            <OfficeLocationCard
              key={index}
              city={item?.city}
              address={item?.address}
            />
          ))}
        </div>
      </div>
      {/* Lower Card */}
      <div className="w-full py-[42px] lg:py-0 px-customPaddingMobile  lg:px-customPadding mt-4 lg:mt-20  2xl:w-[1292px] 2xl:mx-auto 2xl:px-0">
        <div className="bg-[#F8F8F8] pb-[26px] lg:pb-0 lg:pl-7 mid:pl-[56px] w-full min-h-[408px]   lg:flex lg:flex-row-reverse justify-between">
          {/* Right part */}
          <img
            src="/contactus.png"
            className="w-full lg:max-w-[592px]"
            alt=""
          />

          {/* Left part */}

          <div className="mt-11 lg:mt-20 pl-[30px] lg:mr-4 ">
            <p className="font-spaceGrotesk font-normal  text-mobile-h2 sm:text-[40px] sm:leading-10 lg:text-web-h2 leading-9 lg:leading-[59px] text-brand-textBlack max-w-[360px] lg:max-w-[500px]">
              24/7 LIVE SUPPORT
            </p>
            <p className="font-openSans font-normal mt-[10px] lg:mt-4 max-w-[262px] lg:max-w-[336px]  text-mobile-body-sm lg:text-web-body-lg leading-4 lg:leading-[22px] text-brand-textLightGrey  ">
              Chat with our experts who are available 24/7 to get all your
              queries addressed.
            </p>

            <Button className="w-[146px] flex h-10 lg:h-[60px] lg:w-[187px] mt-11 sm:mt-10 md:mt-14 lg:mt-[52px]">
              <p className="font-openSans font-semibold text-mobile-body-md lg:text-[22px] leading-[30px] text-white">
                Chat Now
              </p>
            </Button>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default ContactUsPage;
